export function openLink(link) {
  window.open(link, "_blank");
}
